import { type FC } from 'react'

import { Dialog, DialogContent } from 'base-ui'

import { LoginRegistrationUserLoginModal } from '../../../login-registration'
import { type DirectContactFormSubmitStatus } from '../../hooks/useDirectContactFormSubmit'

import { DirectContactFormHookFormDialogBody } from './DirectContactFormHookFormDialogBody'
import { useDirectContactFormHookFormDialogAuthentication } from './DirectContactFormHookFormDialogContext'
import { type DirectContactFormHookFormDialogValues } from './DirectContactFormHookFormDialogModel'
import { DirectContactFormHookFormDialogTitle } from './DirectContactFormHookFormDialogTitle'
import { type DirectContactFormHookFormFieldsProps } from './DirectContactFormHookFormFields'

export const DirectContactFormHookFormDialogContent: FC<{
  configuration: DirectContactFormHookFormFieldsProps['configuration']
  contactFormLaunchOrigin?: string
  handleClose: () => void
  handleSuccessNotificationClose: () => void
  isCancelContract: boolean
  isMutating: boolean
  isOpen: boolean
  onSubmit: (values: DirectContactFormHookFormDialogValues) => Promise<void>
  onSuccessClose?: () => void
  submitStatus: DirectContactFormSubmitStatus
}> = ({
  configuration,
  contactFormLaunchOrigin,
  handleClose,
  handleSuccessNotificationClose,
  isCancelContract,
  isMutating,
  isOpen,
  onSubmit,
  onSuccessClose,
  submitStatus,
}) => {
  const { handleLoginModalClose, handleLoginSuccess, isLoginModalOpen } =
    useDirectContactFormHookFormDialogAuthentication()

  const open = isOpen && !isLoginModalOpen

  return (
    <>
      <Dialog onClose={handleClose} open={open}>
        <DirectContactFormHookFormDialogTitle
          isSuccess={submitStatus === 'success'}
          onClose={handleClose}
        />
        <DialogContent
          className="flex h-full flex-col pt-1"
          data-contact-form-launch-origin={contactFormLaunchOrigin}
        >
          <DirectContactFormHookFormDialogBody
            configuration={configuration}
            handleSuccessNotificationClose={handleSuccessNotificationClose}
            isCancelContract={isCancelContract}
            isMutating={isMutating}
            onSubmit={onSubmit}
            onSuccessClose={onSuccessClose}
            submitStatus={submitStatus}
          />
        </DialogContent>
      </Dialog>
      <LoginRegistrationUserLoginModal
        afterLoggedIn={handleLoginSuccess}
        onClose={handleLoginModalClose}
        open={isLoginModalOpen}
      />
    </>
  )
}
